






















import { Component, Prop, Vue } from 'nuxt-property-decorator'
import componentLoadingDots from '~/components/loading/dots.vue'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    componentLoadingDots,
  },
})
export default class ComponentFormTextarea extends Vue {
  @Prop({ default: null, type: String }) readonly label!: null
  @Prop({ default: null, type: String }) readonly description!: null
  @Prop({ default: false, type: Boolean }) readonly loading!: boolean
  @Prop({ default: '-1', type: String }) readonly tabindex!: string
  @Prop({ default: null, type: String }) readonly mask!: string
  @Prop({ default: false, type: Boolean }) readonly error!: boolean
  @Prop({ default: false, type: Boolean }) readonly success!: boolean
  @Prop({ default: false, type: Boolean }) readonly autofocus!: boolean
  @Prop({ default: '', type: String }) readonly value!: string

  private $style!: IStyle
  private styleAnimation!: IStyle

  private disabled = false

  private async mounted(): Promise<void> {
    if (process.client) {
      const input = this.$refs.input as HTMLInputElement
      if (this.autofocus) {
        if (!this.$device.isIos) {
          input.focus()
        }
      }
      const that = this
      if (that.mask) {
        this.disabled = true
        await import('inputmask').then((module) => {
          module
            .default({
              mask: that.mask,
              showMaskOnHover: false,
            })
            .mask(input)

          this.disabled = false
          setTimeout(() => {
            if (this.autofocus) {
              if (!this.$device.isIos) {
                input.focus()
              }
            }
          })
        })
      }
    }
  }

  private get classWrapper() {
    return {
      [this.$style.inputWrapper]: true,
      [this.$style.error]: this.error && !this.isFocus,
      [this.$style.active]: this.value.trim().length > 0 || this.isFocus,
      [this.styleAnimation.shakeHorizontal]: this.error && !this.isFocus,
      [this.$style.success]: this.success,
    }
  }

  private get classInput() {
    return {
      [this.$style.input]: true,
      [this.$style.filled]: this.value.trim().length > 0,
    }
  }

  private isFocus = false
}
